import { DownOutlined, TeamOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import { useState } from 'react';
import styled from 'styled-components';

type Props = {
  value?: number;
  onChange?: (value: number) => void;
  max?: number;
};

// Grid of selectable group sizes (1..max) shown inside a popover.
const GroupNumberPopover = ({ value = 1, onChange, max = 24 }: Props) => {
  const [open, setOpen] = useState(false);
  const numbers = Array.from({ length: max }, (_, i) => i + 1);

  const handleSelect = (num: number) => {
    onChange?.(num);
    setOpen(false);
  };

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      trigger="click"
      placement="bottom"
      overlayInnerStyle={{ padding: 0, borderRadius: 8 }}
      content={
        <NumberGrid>
          {numbers.map((num) => (
            <NumberCell
              key={num}
              type="button"
              data-active={num === value}
              onClick={() => handleSelect(num)}
            >
              {num}
            </NumberCell>
          ))}
        </NumberGrid>
      }
    >
      <TriggerButton type="button">
        <span className="label">
          <TeamOutlined />
          Party of {value}
        </span>
        <DownOutlined className="chevron" />
      </TriggerButton>
    </Popover>
  );
};

export default GroupNumberPopover;

const TriggerButton = styled.button`
  display: flex;
  height: 56px;
  align-items: center;
  gap: 8px;
  padding: 2px 12px;
  border: none;
  border-radius: 4px;
  background: #2563eb;
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
  .label {
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: Poppins;
    font-size: 18px;
    font-weight: 500;
  }
  .chevron {
    font-size: 12px;
  }
`;

const NumberGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
  width: 520px;
  max-width: 80vw;
  padding: 16px;
`;

const NumberCell = styled.button`
  display: flex;
  height: 64px;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccd4dc;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
  color: #1d2129;
  font-family: Poppins;
  font-size: 24px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &[data-active='true'] {
    background: #2563eb;
    border-color: #e9edf2;
    color: #fff;
  }
`;
